var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassroomInactiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.14062H1V11.1528H15V2.14062Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.64844,
    y: 8.41016,
    width: 10.7059,
    height: 0.821814,
    rx: 0.410907,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82911 11.1523L3.08984 14.9992",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9111 14.9992L10.1719 11.1523",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1V2.14128",
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomInactiveIcon);
export default __webpack_public_path__ + "static/media/classroomInactiveIcon.63ee57069727f83c8a0eb0c8fba61e5e.svg";
export { ForwardRef as ReactComponent };